/**
* @file 资源管理-司机资源-创建/修改司机信息
* */
<template>
  <div>
    <div class="dz-create">
      <h3>{{ title }}</h3>
      <el-form :model="form" :rules="rules" ref="form" label-width="130px" label-position="right"
               :validate-on-rule-change="false" :disabled="auditInfo.applyStatus == 4">
        <div class="formTitle">
          <span>个人信息</span>
        </div>
        <div class="table-container">
          <el-row :gutter="0" class="table-row">
            <el-col :span="12" class="table-cell">
              <el-form-item label="机构名称" prop="organizationId">
                <el-select v-model="form.organizationId" filterable disabled
                           v-if="mixinUserInfo?.organizationType === 1">
                  <el-option v-for="(item, i) in organizations" :key="i" :value="item.id"
                             :label="item.name">
                  </el-option>
                </el-select>
                <span v-else>{{
                    organizations && organizations[0] && organizations[0].name
                  }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="table-cell">
              <el-form-item label="所属渠道" prop="channelName">
                <el-input v-model="form.channelName" placeholder="-" :maxlength="30"
                          disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="0" class="table-row">
            <el-col :span="12" class="table-cell">
              <el-form-item label="司机姓名" prop="name">
                <el-input v-model="form.name" placeholder="请输入" maxlength="10"
                          show-word-limit></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="table-cell">
              <el-form-item label="手机号码" prop="phone">
                <el-input v-model="form.phone" placeholder="请输入" maxlength="11" show-word-limit
                          disabled>
                  <template slot="prepend">+86</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="0" class="table-row">
            <el-col :span="12" class="table-cell">
              <el-form-item label="身份证号" prop="idCard">
                <el-input v-model="form.idCard" placeholder="请输入" maxlength="18"
                          show-word-limit></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="table-cell">
              <el-form-item label="司机年龄" prop="age">
                <el-input v-model="form.age" placeholder="-" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="0" class="table-row">
            <el-col :span="12" class="table-cell">
              <el-form-item label="身份证有效期" prop="idCardValidType">
                <el-radio-group @change="changeIdCardValidType" v-model="form.idCardValidType">
                  <el-radio :label="1">短期有效</el-radio>
                  <el-radio :label="2">长期有效</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="table-cell">
              <el-form-item label="证件有效期至" prop="idCardValid">
                <div class="flex-start" style="gap: 12px">
                  <el-date-picker v-model="form.idCardValid" type="date" placeholder="请选择"
                                  :disabled="form.idCardValidType === 2">
                  </el-date-picker>
                  <el-button type="primary" :loading="ocrLoading" @click="ocrRecognize('idCardBackPath')">OCR识别
                  </el-button>
                </div>

              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="0" class="table-row">
            <el-col :span="12" class="table-cell">
              <el-form-item label="身份证人像面" prop="idCardFrontPath">
                <up-img :file.sync="form.idCardFrontPath" width="150" height="80" :disabled="true"/>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="table-cell">
              <el-form-item label="身份证国徽面" prop="idCardBackPath">
                <div class="flex-start">
                  <up-img :file.sync="form.idCardBackPath" width="150" height="80" :disabled="true"/>

                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="formTitle">
          <span>驾驶证信息</span>
        </div>
        <div class="table-container">
          <el-row :gutter="0" class="table-row">
            <el-col :span="12" class="table-cell">
              <el-form-item label="准驾车型" prop="driverClass">
                <el-select v-model="form.driverClass" placeholder="请选择">
                  <el-option v-for="item in $const.DRIVERSHORTTYPE" :key="item.value"
                             :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="table-cell">
              <el-form-item label="初次领证日期" prop="firstIssueDate">
                <el-date-picker v-model="form.firstIssueDate" type="date" placeholder="请选择">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="0" class="table-row">
            <el-col :span="12" class="table-cell">
              <el-form-item label="驾驶证有效期" prop="driverLicenseValidType">
                <el-radio-group v-model="form.driverLicenseValidType">
                  <el-radio :label="1">短期有效</el-radio>
                  <el-radio :label="2">长期有效</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="table-cell">
              <el-form-item label="证件有效期至" prop="driverLicenceValid"
                            v-if="form.driverLicenseValidType === 1">
                <el-date-picker v-model="form.driverLicenceValid" type="date" placeholder="请选择">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="证件有效期至" prop="driverLicenceValid" v-else>
                <el-date-picker v-model="form.driverLicenceValid" type="date" placeholder="请选择"
                                disabled>
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="0" class="table-row">
            <el-col :span="24" class="table-cell">
              <el-form-item label="驾驶证正页" prop="driverLicensePath">
                <up-img :file.sync="form.driverLicensePath" width="150" height="80" :disabled="true"/>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="formTitle">
          <span>车辆信息</span>
        </div>
        <div class="table-container">
          <el-row :gutter="0" class="table-row">
            <el-col :span="12" class="table-cell">
              <el-form-item label="车辆号牌" prop="licenseNo">
                <el-input v-model="form.licenseNo" placeholder="请输入" maxlength="15"/>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="table-cell">
              <el-form-item label="号牌颜色" prop="licenseColor">
                <el-select v-model="form.licenseColor" filterable>
                  <el-option v-for="item in $const.LICENSECOLOR" :key="item.value" :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="0" class="table-row">
            <el-col :span="12" class="table-cell">
              <el-form-item label="车辆使用性质" prop="useCharacter">
                <el-select v-model="form.useCharacter" filterable>
                  <el-option v-for="item in $const.USENATURE" :label="item.label" :key="item.value"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="table-cell">
              <el-form-item label="核载人数" prop="vehicleSeat">
                <el-select v-model="form.vehicleSeat" filterable>
                  <el-option v-for="item in $const.SEATNUMBER" :label="item.label" :key="item.value"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="0" class="table-row">
            <el-col :span="12" class="table-cell">
              <el-form-item label="车辆型号" prop="vehicleModel">
                <el-input v-model="form.vehicleModel" placeholder="请输入" maxlength="30"/>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="table-cell">
              <el-form-item label="注册日期" prop="registerDate">
                <el-date-picker v-model="form.registerDate" type="date" placeholder="请选择"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="0" class="table-row">
            <el-col :span="24" class="table-cell">
              <el-form-item label="车身颜色" prop="vehicleColor">
                <el-select v-model="form.vehicleColor" filterable>
                  <el-option v-for="item in $const.VEHICLECOLOR" :key="item.value" :label="item.label"
                             :value="item.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="0" class="table-row">
            <el-col :span="12" class="table-cell">
              <el-form-item label="行驶证正面" prop="drivingLicenseFront">
                <up-img :file.sync="form.drivingLicenseFront" width="190" height="80"
                        :disabled="true"/>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="table-cell">
              <el-col :span="24" class="table-cell">
                <el-form-item label="车辆照片" prop="vehiclePhoto">
                  <up-img :file.sync="form.vehiclePhoto" width="190" height="80" :disabled="true"/>
                </el-form-item>
              </el-col>
            </el-col>
          </el-row>
        </div>
        <div class="formTitle">
          <span>交强险信息</span>
        </div>
        <div class="table-container">
          <el-row :gutter="0" class="table-row">
            <el-col :span="24" class="table-cell">
              <el-form-item label="保险单号" prop="compulsoryTrafficInsuranceNo">
                <div class="flex-start" style="gap: 12px">
                  <el-input v-model="form.compulsoryTrafficInsuranceNo" placeholder="请输入" maxlength="30"
                            show-word-limit></el-input>
                  <el-button type="primary" :loading="ocrLoading" @click="ocrRecognize('compulsoryTrafficInsurance')">
                    OCR识别
                  </el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="0" class="table-row">

            <el-col :span="12" class="table-cell">
              <el-form-item label="保单有效期起" prop="compulsoryTrafficInsuranceStart">
                <el-date-picker v-model="form.compulsoryTrafficInsuranceStart" type="date"
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                style="width: 100%;" @change="handleCompulsoryStartChange">
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="12" class="table-cell">
              <el-form-item label="保单有效期止" prop="compulsoryTrafficInsuranceEnd">
                <el-date-picker v-model="form.compulsoryTrafficInsuranceEnd" type="date"
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                style="width: 100%;" @change="handleCompulsoryEndChange">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="0" class="table-row">
            <el-col :span="24" class="table-cell">
              <el-form-item label="保单照片" prop="compulsoryTrafficInsurance">
                <div class="flex-start">
                  <up-img :file.sync="form.compulsoryTrafficInsurance" width="150" height="80"
                          :disabled="true" @ocr-text="ocrText($event, 'compulsoryTrafficInsuranceNo')"/>

                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="formTitle">
          <span>商业险信息</span>
        </div>
        <div class="table-container">
          <el-row :gutter="0" class="table-row">
            <el-col :span="24" class="table-cell">
              <el-form-item label="保险单号" prop="commercialInsuranceNo">
                <div class="flex-start" style="gap: 12px">
                  <el-input v-model="form.commercialInsuranceNo" placeholder="请输入" maxlength="30"
                            show-word-limit></el-input>

                  <el-button type="primary" :loading="ocrLoading" @click="ocrRecognize('commercialInsurance')">OCR识别
                  </el-button>
                </div>
              </el-form-item>
            </el-col>

          </el-row>
          <el-row :gutter="0" class="table-row">
            <el-col :span="12" class="table-cell">
              <el-form-item label="保单有效期起" prop="commercialInsuranceStart">
                <el-date-picker v-model="form.commercialInsuranceStart" type="date"
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                style="width: 100%;" @change="handleCommercialStartChange">
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :span="12" class="table-cell">
              <el-form-item label="保单有效期止" prop="commercialInsuranceEnd">
                <el-date-picker v-model="form.commercialInsuranceEnd" type="date"
                                range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                style="width: 100%;" @change="handleCommercialEndChange">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="0" class="table-row">
            <el-col :span="24" class="table-cell">
              <el-form-item label="保单照片" prop="commercialInsurance">
                <div class="flex-start">
                  <up-img :file.sync="form.commercialInsurance" width="150" height="80"
                          :disabled="true" @ocr-text="ocrText($event, 'commercialInsuranceNo')"/>


                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </div>

        <template v-if="auditInfo.applyStatus === 4">
          <div class="formTitle">审核意见</div>

          <el-form ref="auditForm1" :model="auditForm" label-width="130px" :rules="auditRules"
                   :disabled="operationType === 'view'">
            <div class="table-container">
              <el-row :gutter="0" class="table-row">
                <el-col :span="24" class="table-cell">
                  <el-form-item label="是否通过" prop="applyStatus">
                    <el-radio-group v-model="auditForm.applyStatus">
                      <el-radio :label="3">通过</el-radio>
                      <el-radio :label="4">不通过</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="0" class="table-row" v-if="auditForm.applyStatus === 4">
                <el-col :span="24" class="table-cell">
                  <el-form-item label="拒绝理由" prop="refusalReason">
                    <el-select v-model="auditForm.refusalReason" filterable placeholder="请选择拒绝理由">
                      <el-option v-for="(item, i) in reason" :key="i" :label="item.label"
                                 :value="item.label"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="0" class="table-row" v-if="
                                auditForm.applyStatus == 4 && auditForm.refusalReason === '其他'
                            ">
                <el-col :span="24" class="table-cell">
                  <el-form-item prop="reasonInput" label=" ">
                    <el-input type="textarea" :rows="3" placeholder="请输入拒绝原因" :maxlength="120"
                              show-word-limit style="width: 480pX;" v-model="auditForm.reasonInput">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-form>
        </template>
        <div style="margin-top: 16px;">
          <!-- <span v-if="operationType === 'view'">
                  <el-button type="primary" @click="cancelAudit">关闭</el-button>
              </span> -->
          <span v-if="operationType !== 'view'">
                        <el-button @click="rejectAudit">驳回</el-button>
                        <el-button type="primary" @click="sureAudit(3)">通过</el-button>
                    </span>
        </div>
      </el-form>
    </div>
    <el-dialog title="驳回原因" append-to-body :visible.sync="dialogVisible" width="600px" :before-close="dialogCancel"
               destroy-on-close :close-on-click-modal="false">
      <el-form ref="auditForm" :model="auditForm" label-width="80px" :rules="auditRules">
        <el-form-item label="拒绝理由" prop="refusalReason">
          <el-select v-model="auditForm.refusalReason" filterable placeholder="请选择拒绝理由">
            <el-option v-for="(item, i) in reason" :key="i" :label="item.label"
                       :value="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="reasonInput" label=" " v-if="auditForm.refusalReason === '其他'">
          <el-input type="textarea" :rows="3" placeholder="请输入拒绝原因" :maxlength="120" show-word-limit
                    v-model="auditForm.reasonInput">
          </el-input>
        </el-form-item>
        <div class="flex-end">
          <el-button @click="dialogCancel">取消</el-button>
          <el-button type="primary" @click="sureAudit(4)">提交</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import upImg from "@/components/upImg";
import externalLinks from '@/assets/json/externalLinks';

export default {
  name: "dzCreate",
  components: {
    upImg
  },
  props: {
    operationType: {
      type: String,
      default: 'view'
    },
    auditInfo: {
      type: Object,
      required: true,
      default: () => ({})
    },
    title: {
      type: String,
      default: "新增司机"
    }
  },
  data() {
    return {
      ocrLoading: false,
      loading: false,
      form: {
        organizationId: "",
        companyName: "",
        name: "",
        phone: "",
        idCard: "",
        password: "",
        confirmPassword: "",
        gender: "",
        idCardValidType: 1,
        idCardValid: "",
        idCardFrontPath: "",
        idCardBackPath: "",
        headPortrait: "",
        driverClass: "",
        firstIssueDate: "",
        driverLicenseValidType: 1,
        driverLicenceValid: "",
        driverLicensePath: "",
        driverLicenseBackPath: "",
        qualificationsPath: "",
        emergency: "",
        emergencyPhone: ""
      },

      organizationOptions: [],
      driverTypeOptions: [
        {value: "A1", label: "A1"},
        {value: "A2", label: "A2"},
        {value: "A3", label: "A3"},
        {value: "B1", label: "B1"},
        {value: "B2", label: "B2"},
        {value: "C1", label: "C1"},
        {value: "C2", label: "C2"}
      ],
      // 拒绝id
      refuseId: "",
      // 拒绝理由（从配置文件获取）
      sfxReason: externalLinks.auditRejectReasons.sfx,
      czReason: externalLinks.auditRejectReasons.cz,
      auditForm: {
        applyStatus: "",
        refusalReason: "",
        reasonInput: "",
      },
      auditRules: {
        applyStatus: [
          {required: true, message: "请选择审核状态", trigger: "change"},
        ],
        refusalReason: [
          {required: true, message: "请选择拒绝理由", trigger: "change"},
        ],
        reasonInput: [
          {required: false, message: "请输入拒绝理由", trigger: "blur"},
        ],
      },
      dialogVisible: false
    };
  },
  computed: {
    rules() {
      return {
        name: [
          {required: this.operationType !== 'view', message: "请输入司机姓名", trigger: "blur"}
        ],
        idCard: [
          {required: this.operationType !== 'view', message: "请输入身份证号", trigger: "blur"},
          {
            pattern: /(^\d{15}$)|(^\d{17}(\d|X|x)$)/,
            message: "请输入正确的身份证号",
            trigger: "blur"
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback();
                return;
              }

              // 15位身份证校验
              if (value.length === 15) {
                callback();
                return;
              }

              // 18位身份证校验：验证出生日期
              if (value.length === 18) {
                const year = value.substring(6, 10);
                const month = value.substring(10, 12);
                const day = value.substring(12, 14);

                const date = new Date(`${year}-${month}-${day}`);
                const now = new Date();

                if (
                    date.getFullYear() !== parseInt(year) ||
                    date.getMonth() + 1 !== parseInt(month) ||
                    date.getDate() !== parseInt(day) ||
                    date > now ||
                    parseInt(year) < 1900
                ) {
                  callback(new Error("身份证号中的出生日期无效"));
                  return;
                }
              }

              callback();
            },
            trigger: "blur"
          }
        ],
        idCardValidType: [
          {required: this.operationType !== 'view', message: "请选择身份证有效期类型", trigger: "change"}
        ],
        idCardValid: [
          {
            required: this.operationType !== 'view',
            message: "请选择证件有效期",
            trigger: "change",
            validator: (rule, value, callback) => {
              if (this.form.idCardValidType === 2) {
                callback();
              } else if (this.operationType !== 'view' && !value) {
                callback(new Error("请选择证件有效期"));
              } else {
                callback();
              }
            }
          }
        ],
        driverClass: [
          {required: this.operationType !== 'view', message: "请选择准驾车型", trigger: "change"}
        ],
        firstIssueDate: [
          {required: this.operationType !== 'view', message: "请选择初次领证日期", trigger: "change"}
        ],
        driverLicenseValidType: [
          {required: this.operationType !== 'view', message: "请选择驾驶证有效期类型", trigger: "change"}
        ],
        driverLicenceValid: [
          {required: this.operationType !== 'view', message: "请选择证件有效期", trigger: "change"}
        ],
        licenseNo: [
          {required: this.operationType !== 'view', message: "请输入车辆号牌码", trigger: "blur"},
          {
            validator: (rule, value, callback) => {
              // 普通车辆号牌正则
              const normalReg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-Z0-9]{4}[A-Z0-9挂学警港澳]$/;
              // 新能源车辆号牌正则
              const newEnergyReg = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-Z0-9]{6}$/;

              if (!value) {
                callback(new Error("请输入车辆号牌码"));
                return;
              }

              if (value.length === 7) {
                if (!normalReg.test(value)) {
                  callback(new Error("请输入正确的车辆号牌码"));
                  return;
                }
              } else if (value.length === 8) {
                if (!newEnergyReg.test(value)) {
                  callback(new Error("请输入正确的新能源车辆号牌码"));
                  return;
                }
              } else {
                callback(new Error("车辆号牌码长度必须为7位或8位"));
                return;
              }

              callback();
            },
            trigger: "blur"
          }
        ],
        licenseColor: [
          {required: this.operationType !== 'view', message: "请选择号牌颜色", trigger: "change"}
        ],
        useCharacter: [
          {required: this.operationType !== 'view', message: "请选择车辆使用性质", trigger: "change"}
        ],
        vehicleModel: [
          {required: this.operationType !== 'view', message: "请输入车辆型号", trigger: "change"}
        ],
        vehicleSeat: [
          {required: this.operationType !== 'view', message: "请选择核载人数", trigger: "change"}
        ],
        registerDate: [
          {required: this.operationType !== 'view', message: "请选择注册日期", trigger: "change"}
        ],
        vehicleColor: [
          {required: this.operationType !== 'view', message: "请选择车身颜色", trigger: "change"}
        ],
        drivingLicenseFront: [
          {required: this.operationType !== 'view', message: "请上传行驶证正面", trigger: "change"}
        ],
        vehiclePhoto: [
          {required: this.operationType !== 'view', message: "请上传车辆照片", trigger: "change"}
        ],
      }
    },
    reason() {
      return this.mixinUserInfo.platformType == 3
          ? this.sfxReason
          : this.czReason;
    },
  },
  watch: {
    "auditForm.refusalReason"(val) {
      this.auditRules.reasonInput[0].required = val == "其他";
    },

    'form.driverLicenseValidType'(newVal) {
      if (newVal === 2) { // 长期有效
        this.form.driverLicenceValid = new Date('2099-12-31 00:00:00');
      } else if (newVal === 1) { // 短期有效
        this.form.driverLicenceValid = '';
      }
    },
    'form.idCard'(newVal) {
      if (newVal && newVal.length >= 17) {
        // 身份证号码第17位：奇数为男，偶数为女
        const sexCode = parseInt(newVal.charAt(16), 10);
        this.form.gender = sexCode % 2 === 1 ? '男' : '女';
      } else {
        this.form.gender = '';
      }
    }
  },

  async created() {
    await this.mixinOrganizations();
    // 将日期类型转换为13位时间戳
    const dateFields = ['idCardValid', 'firstIssueDate', 'driverLicenceValid', 'registerDate', 'commercialInsuranceEnd',
      'commercialInsuranceStart',
      'compulsoryTrafficInsuranceStart',
      'compulsoryTrafficInsuranceEnd'];
    dateFields.forEach(field => {
      if (this.auditInfo[field]) {
        // 转换为13位时间戳（毫秒）
        this.auditInfo[field] = this.auditInfo[field] * 1000;
      }
    });
    this.auditInfo.idCardValidType = this.auditInfo.idCardValid == 4102329600000 ? 2 : 1;
    this.auditInfo.driverLicenseValidType = this.auditInfo.driverLicenceValid == 4102329600000 ? 2 : 1;

    console.log(this.auditInfo)
    this.form = {
      ...this.auditInfo,
      // compulsoryTrafficInsuranceStart: this.auditInfo.compulsoryTrafficInsuranceStart ? Math.floor(this.auditInfo.compulsoryTrafficInsuranceStart / 1000) : '',
      // compulsoryTrafficInsuranceEnd: this.auditInfo.compulsoryTrafficInsuranceEnd ? Math.floor(this.auditInfo.compulsoryTrafficInsuranceEnd / 1000) : '',
      // commercialInsuranceStart: this.auditInfo.commercialInsuranceStart ? Math.floor(this.auditInfo.commercialInsuranceStart / 1000) : '',
      // commercialInsuranceEnd: this.auditInfo.commercialInsuranceEnd ? Math.floor(this.auditInfo.commercialInsuranceEnd / 1000) : '',
      //
      // compulsoryTrafficInsuranceDate:
      //     this.auditInfo.compulsoryTrafficInsuranceStart && this.auditInfo.compulsoryTrafficInsuranceEnd ?
      //         [this.auditInfo.compulsoryTrafficInsuranceStart, this.auditInfo.compulsoryTrafficInsuranceEnd] :
      //         [],
      // commercialInsuranceDate: this.auditInfo.commercialInsuranceStart && this.auditInfo.commercialInsuranceEnd
      //     ? [this.auditInfo.commercialInsuranceStart, this.auditInfo.commercialInsuranceEnd]
      //     : [],
    }
    const reasonIndex = this.reason.findIndex((item) => {
      return (
          this.auditInfo.refusalReason != "其他" && item.label === this.auditInfo.refusalReason
      );
    });
    this.auditForm = {
      applyStatus: this.auditInfo.applyStatus > 2 ? this.auditInfo.applyStatus : "",
      refusalReason:
          this.auditInfo.refusalReason && reasonIndex == -1
              ? "其他"
              : this.auditInfo.refusalReason,
      reasonInput:
          this.auditInfo.refusalReason && reasonIndex == -1 ? this.auditInfo.refusalReason : "",
    };
    console.log(this.form)
  },
  methods: {
    ocrText(text, key) {
      this.form[key] = text;
    },
    // 交强险开始日期变化
    handleCompulsoryStartChange(val) {
      if (val) {
        // 创建一个新的日期对象，避免直接修改原始值
        const endDate = new Date(val);
        // 加一年
        endDate.setFullYear(endDate.getFullYear() + 1);
        // 减去一天，确保结束日期是完整的一年
        endDate.setDate(endDate.getDate() - 1);
        // 设置到结束日期
        this.form.compulsoryTrafficInsuranceEnd = endDate;
      }
    },

    // 交强险结束日期变化
    handleCompulsoryEndChange(val) {
      if (val) {
        // 创建一个新的日期对象，避免直接修改原始值
        const startDate = new Date(val);
        // 加上一天
        startDate.setDate(startDate.getDate() + 1);
        // 减一年
        startDate.setFullYear(startDate.getFullYear() - 1);
        // 设置到开始日期
        this.form.compulsoryTrafficInsuranceStart = startDate;
      }
    },

    // 商业险开始日期变化
    handleCommercialStartChange(val) {
      if (val) {
        // 创建一个新的日期对象，避免直接修改原始值
        const endDate = new Date(val);
        // 加一年
        endDate.setFullYear(endDate.getFullYear() + 1);
        // 减去一天，确保结束日期是完整的一年
        endDate.setDate(endDate.getDate() - 1);
        // 设置到结束日期
        this.form.commercialInsuranceEnd = endDate;
      }
    },

    // 商业险结束日期变化
    handleCommercialEndChange(val) {
      if (val) {
        // 创建一个新的日期对象，避免直接修改原始值
        const startDate = new Date(val);
        // 加上一天
        startDate.setDate(startDate.getDate() + 1);
        // 减一年
        startDate.setFullYear(startDate.getFullYear() - 1);
        // 设置到开始日期
        this.form.commercialInsuranceStart = startDate;
      }
    },

    async changeIdCardValidType(newVal) {
      if (newVal == 2) { // 长期有效
        this.form.idCardValid = new Date('2099-12-31 00:00:00');
      } else if (newVal == 1) { // 短期有效
        this.form.idCardValid = '';
      }
    },
    async ocrRecognize(type) {
      this.ocrLoading = true
      const url = {
        compulsoryTrafficInsurance: "/api/v1/common/ocr/insurance/compulsory",
        commercialInsurance: "/api/v1/common/ocr/insurance/commercial",
        idCardBackPath: "/api/v1/common/ocr/idCard/back"
      }

      const {code, data} = await this.$axios.post(url[type], {
        imagePath: this.form[type],
      })
      this.ocrLoading = false
      if (code === 1 ) {
        if (type === 'compulsoryTrafficInsurance' && data.policyNo) {
          this.form.compulsoryTrafficInsuranceNo = data.policyNo
          this.form.compulsoryTrafficInsuranceStart = data.effectiveDate * 1000
          this.form.compulsoryTrafficInsuranceEnd = data.expiryDate * 1000
        } else if (type === 'commercialInsurance' && data.policyNo) {
          this.form.commercialInsuranceNo = data.policyNo
          this.form.commercialInsuranceStart = data.effectiveDate * 1000
          this.form.commercialInsuranceEnd = data.expiryDate * 1000
        } else if (type === 'idCardBackPath' && data.idCardValid) {
          this.form.idCardValid = data.idCardValid * 1000
          if(data.validDate === '20991231'){
            this.form.idCardValidType = 2
          }else {
            this.form.idCardValidType = 1
          }

        }else  {
          this.$message.error('查询失败')
          return
        }
        this.$message.success('查询成功')
      }
    },
    dialogCancel() {
      this.dialogVisible = false
    },
    sureAudit(applyStatus) {
      if (applyStatus == 4) {
        this.$refs.auditForm.validate(async (valid) => {
          if (valid) {
            this.$refs.form.validate(async (fvalid) => {
              if (fvalid) {
                this.auditClick(applyStatus);
              } else {
                this.$message.warning('请完善信息')
                this.dialogVisible = false
              }
            })
          }
        });
      } else {
        this.$refs.form.validate(async (fvalid) => {
          if (fvalid) {
            this.auditClick(applyStatus);
          } else {
            this.$message.warning('请完善信息')
            this.dialogVisible = false
          }
        })
      }

    },
    // 取消审核
    cancelAudit() {
      this.$emit('close')
    },
    rejectAudit() {
      this.dialogVisible = true
    },

    /**
     * 审核
     */
    async auditClick(applyStatus) {
      let url = "/api/v1/manage/driverAndVehicle/audit";
      let params = {
        id: this.auditInfo.id,
        name: this.form.name,
        idCard: this.form.idCard,
        idCardValid: this.form.idCardValid ? Math.floor(new Date(this.form.idCardValid).getTime() / 1000) : null,
        driverClass: this.form.driverClass,
        firstIssueDate: this.form.firstIssueDate ? Math.floor(new Date(this.form.firstIssueDate).getTime() / 1000) : null,
        driverLicenceValid: this.form.driverLicenceValid ? Math.floor(new Date(this.form.driverLicenceValid).getTime() / 1000) : null,
        licenseNo: this.form.licenseNo,
        licenseColor: this.form.licenseColor,
        useCharacter: this.form.useCharacter,
        vehicleSeat: this.form.vehicleSeat,
        registerDate: this.form.registerDate ? Math.floor(new Date(this.form.registerDate).getTime() / 1000) : null,
        vehicleColor: this.form.vehicleColor,
        vehicleModel: this.form.vehicleModel,
        compulsoryTrafficInsuranceNo: this.form.compulsoryTrafficInsuranceNo,
        // compulsoryTrafficInsuranceStart: this.form.compulsoryTrafficInsuranceDate[0] ? Math.floor(new Date(this.form.compulsoryTrafficInsuranceDate[0]).getTime() / 1000) : null,
        // compulsoryTrafficInsuranceEnd: this.form.compulsoryTrafficInsuranceDate[1] ? Math.floor(new Date(this.form.compulsoryTrafficInsuranceDate[1]).getTime() / 1000) : null,
        compulsoryTrafficInsuranceStart: this.form.compulsoryTrafficInsuranceStart ? Math.floor(this.form.compulsoryTrafficInsuranceStart / 1000) : null,
        compulsoryTrafficInsuranceEnd: this.form.compulsoryTrafficInsuranceEnd ? Math.floor(this.form.compulsoryTrafficInsuranceEnd / 1000) : null,
        commercialInsuranceNo: this.form.commercialInsuranceNo,
        // commercialInsuranceStart: this.form.commercialInsuranceDate[0] ? Math.floor(new Date(this.form.commercialInsuranceDate[0]).getTime() / 1000) : null,
        // commercialInsuranceEnd: this.form.commercialInsuranceDate[1] ? Math.floor(new Date(this.form.commercialInsuranceDate[1]).getTime() / 1000) : null,
        commercialInsuranceStart: this.form.commercialInsuranceStart ? Math.floor(this.form.commercialInsuranceStart / 1000) : null,
        commercialInsuranceEnd: this.form.commercialInsuranceEnd ? Math.floor(this.form.commercialInsuranceEnd / 1000) : null,
        applyStatus: applyStatus,
        refusalReason:
            this.auditForm.refusalReason === "其他"
                ? this.auditForm.reasonInput
                : this.auditForm.refusalReason,
      };
      let data = await this.$axios.put(url, params);
      if (data && data.code === 1) {
        this.$message.success("审核完成！");
        this.cancelAudit();
      }
    },
  }
};
</script>

<style lang="less" scoped>
.dz-create {

  .formTitle {
    font-size: 16px;
    font-weight: bold;
    margin: 20px 0 10px;
  }

  .table-container {
    border: 1px solid #EBEEF5;
    border-bottom: none;
    border-radius: 8px;
    overflow: hidden;
  }

  .table-row {
    margin: 0;

    &:last-child {
      .table-cell {
        border-bottom: 1px solid #EBEEF5;
      }
    }
  }

  .table-cell {
    border-bottom: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;
    padding: 0;
    margin: 0;

    &:last-child {
      border-right: none;
    }
  }

  ::v-deep .el-form {
    margin-top: 0;

  }

  ::v-deep .el-form-item {
    display: flex;
    margin-bottom: 0;

    .el-form-item__label {
      padding: 8px 12px;
      box-sizing: border-box;
      border-right: 1px solid #EBEEF5;
      background: #FBFBFB;
      height: auto;
      margin: 0;
      float: none;
      text-align: left;
      color: #909399;
      font-weight: normal;
    }

    .el-form-item__content {
      flex: 1;
      padding: 8px 12px 0;
      box-sizing: border-box;
      margin-left: 0 !important;
      border: none;
      margin-bottom: 16px;
    }
  }
}
</style>
